import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function PhoneFill(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.807 21.992a19.927 19.927 0 01-8.678-3.081 19.59 19.59 0 01-6.034-6.022 19.836 19.836 0 01-3.087-8.701 2.003 2.003 0 011.19-2.017c.256-.112.532-.17.811-.17h3.017a2.014 2.014 0 012.011 1.725c.196.734.24.912.464 1.833.063.26.14.58.24.987a2.003 2.003 0 01-.452 2.118L8.012 9.939a16.074 16.074 0 006.033 6.021l1.277-1.274a2.012 2.012 0 012.122-.452l.89.224 1.936.479A2.013 2.013 0 0122 16.974v3.01a2.006 2.006 0 01-2.193 2.008z",
    clipRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(PhoneFill);
export default ForwardRef;